export default __webpack_public_path__ + "static/media/Home.ed998a6e.svg";